import { FppSearchFilter } from "@/features/search-filter/components/FppSearchFilter";
import { createFppSearchFilterActions } from "@/features/search-filter/redux/reducer";
import { Box, Row, SeparatorLine, Space } from "@stenajs-webui/core";
import { Card, CardBody, CardHeader } from "@stenajs-webui/elements";
import { SearchFilterContext } from "@stenajs-webui/filter";
import {
  SearchFilterSelectorContext,
  SearchFilterSelectorContextType,
} from "@/features/search-filter/context/searchFilterSelectorContext";
import { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { PageLayout } from "@/components/page-layout/PageLayout";
import { Helmet } from "react-helmet";
import { SpaceValues } from "@/lib/utils/SpaceValues";
import { statisticsByAgreedVolumeFilterSettings } from "../../config/StatisticsByAgreedVolumeFilterConfig";
import { useAgreedVolumeListQuery } from "../../hooks/UseAgreedVolumeListQuery";
import { StatisticsByAgreedVolumeTable } from "../../components/StatisticsByAgreedVolumeTable";
import { useStatisticsYearSelect } from "../../hooks/UseStatisticsYearSelector";

export const StatisticsByAgreedVolumeListPanel = () => {
  const { workspaceState, committedState } = useContext(
    SearchFilterSelectorContext
  ) as SearchFilterSelectorContextType;
  const dispatch = useDispatch();
  const { year: negotiationYear } = useStatisticsYearSelect();

  const routePairCodes = committedState.routePairs.map(
    (routePair) => routePair.code
  );
  const sellers = committedState.sellers.map((seller) => seller.code);
  const salesRegions = committedState.salesRegions.map((salesRegion) =>
    Number.parseInt(salesRegion.code)
  );
  const statNumbers = committedState.statNumbersAndIndexes.map((customer) =>
    Number.parseInt(customer.code)
  );
  const noFiltersSelected = !(
    routePairCodes.length > 0 ||
    salesRegions.length > 0 ||
    statNumbers.length > 0 ||
    sellers.length > 0
  );

  const { agreedVolumeItems, loading, error, fetchAgreedVolumeList } =
    useAgreedVolumeListQuery();

  const onSearch = () => {
    const { sellers, routePairs, statNumbersAndIndexes, salesRegions } =
      workspaceState.formModel;
    !noFiltersSelected &&
      fetchAgreedVolumeList({
        variables: {
          filterOptions: {
            year: negotiationYear,
            routePairCodes: routePairs.map((routePair) => routePair.code),
            salesRegions: salesRegions.map((salesRegion) =>
              parseInt(salesRegion.code)
            ),
            sellers: sellers.map((seller) => seller.code),
            statNumbers: statNumbersAndIndexes.map((customer) =>
              parseInt(customer.code)
            ),
          },
        },
      });
  };

  useEffect(() => {
    onSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [negotiationYear]);

  return (
    <SearchFilterContext
      state={workspaceState}
      actions={createFppSearchFilterActions(
        "statistics.statisticsByAgreedVolume"
      )}
      dispatch={dispatch}
    >
      <Helmet title="Agreed volume - Statistics - FPP" />
      <PageLayout>
        <Card minWidth={"1140px"}>
          <CardHeader text={"Agreed volume"} />
          <CardBody>
            <Row>
              <Box>
                <FppSearchFilter
                  onSearch={onSearch}
                  settings={statisticsByAgreedVolumeFilterSettings}
                />
              </Box>
            </Row>
          </CardBody>
          <SeparatorLine />
          <StatisticsByAgreedVolumeTable
            loading={loading}
            agreedVolumeItems={agreedVolumeItems}
            error={error}
            noFiltersSelected={noFiltersSelected}
          />
          <Space num={SpaceValues.TWENTYFOUR} vertical />
        </Card>
      </PageLayout>
    </SearchFilterContext>
  );
};
